import type { DocumentUploadResponse } from 'job-bank-data-access';
import { getAccessToken } from '@accenturecodefoundry/mfe-pot-shared-auth/core';
import { loadRuntimeConfig } from '../../runtime-config';
import { assetBaseUrl } from '../asset-base-url';

// loadRuntimeConfig fetches and parses env.js on every call with no built-in
// cache -- memoize so every BFF call in this module shares one fetch. Same
// pattern as skills-api.ts (each data module keeps its own memoized config).
let configPromise: ReturnType<typeof loadRuntimeConfig> | undefined;
const getConfig = () => (configPromise ??= loadRuntimeConfig(assetBaseUrl));

export interface DocumentUpload {
  filename: string;
  size: number;
  contentType: string;
  contentBase64: string;
}

export async function uploadDocument(type: string, file: DocumentUpload): Promise<DocumentUploadResponse> {
  const { jobBankBffBaseUrl } = await getConfig();
  const token = getAccessToken();
  const res = await fetch(`${jobBankBffBaseUrl}/api/v1/documents/${encodeURIComponent(type)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(file),
  });
  if (!res.ok) {
    const body: { error?: string } = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `BFF error ${res.status}`);
  }
  return (await res.json()) as DocumentUploadResponse;
}
